import React, { useState } from 'react';
import './MainChatAiWindow.css';
//import PromptButtons from './PromptButtons';

const MainChatAiWindow = ({ user }) => {
  return (
    <div className="new-chat-window">
      <div className="chat-window-header custom-header">
        <img src="/img/star-06.svg" alt="Star Icon" className="custom-icon" />
        <h3 className="custom-heading">Hi {user?.name}! How can I help you today?</h3>
      </div>

      {/* <PromptButtons onPromptSelect={handlePromptSelect} /> */}
    </div>
  );
};

export default MainChatAiWindow;
